// extracted by mini-css-extract-plugin
export var bodySections = "_65-8";
export var gray = "_65-7";
export var green = "_65-4";
export var iconContainer = "_65-9";
export var iconWidgetContainer = "_65-1";
export var phoneIcon = "_65-2";
export var red = "_65-5";
export var statusDot = "_65-3";
export var widgetContainer = "_65-0";
export var yellow = "_65-6";